import type { AlbumPage, AlbumTemplate } from '../types';

/** The trip's map on a page, a cover or across a spread (ADR-0052): no day to pick. */
export const isTripMap = (template: AlbumTemplate) => template === 'TRIP_MAP' || template === 'TRIP_MAP_SPREAD' || template === 'COVER_MAP';

/** Same key the server uses (`albumMaps.service.ts`): a map depends on its frame and its day. */
export function albumMapKey(template: AlbumTemplate, dayId: string | null, legend = true): string {
  return `${template}:${dayId ?? 'trip'}${legend ? '' : ':bare'}`;
}

/** Every map an album's pages show, so the editor can ask for the ones it lacks. */
export function albumMapKeys(pages: AlbumPage[]): string[] {
  return pages.flatMap(p => {
    if (p.template === 'STATS') return p.figuresMap === 'COUNTRY' ? [albumMapKey('STATS', null)] : [];
    if (isTripMap(p.template)) return [albumMapKey(p.template, null, p.mapLegend !== false)];
    if (p.template === 'DAY_MAP') return p.slots.flatMap(s => (s.dayId ? [albumMapKey(p.template, s.dayId, p.mapLegend !== false)] : []));
    return [];
  });
}
